/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AbsenceEntry } from '../model/absenceEntry';
import { AddAbsenceEntryResponse } from '../model/addAbsenceEntryResponse';
import { EditAbsenceEntryResponse } from '../model/editAbsenceEntryResponse';
import { GetAbsenceEntriesResponse } from '../model/getAbsenceEntriesResponse';
import { GetAbsenceEntryResponse } from '../model/getAbsenceEntryResponse';
import { GetAbsenceReasonsResponse } from '../model/getAbsenceReasonsResponse';
import { GetAbsenceTypesResponse } from '../model/getAbsenceTypesResponse';
import { IsAbsenceEnabledResponse } from '../model/isAbsenceEnabledResponse';
import { RemoveAbsenceEntryResponse } from '../model/removeAbsenceEntryResponse';
import { RemoveCurrentAbsenceEntriesResponse } from '../model/removeCurrentAbsenceEntriesResponse';
import { SetCurrentAbsenceEntryResponse } from '../model/setCurrentAbsenceEntryResponse';
import { TimeInterval } from '../model/timeInterval';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { AbsenceServiceInterface }                            from './absence.serviceInterface';


@Injectable()
export class AbsenceService implements AbsenceServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addAbsenceEntry1(body?: AbsenceEntry, observe?: 'body', reportProgress?: boolean): Observable<AddAbsenceEntryResponse>;
    public addAbsenceEntry1(body?: AbsenceEntry, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddAbsenceEntryResponse>>;
    public addAbsenceEntry1(body?: AbsenceEntry, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddAbsenceEntryResponse>>;
    public addAbsenceEntry1(body?: AbsenceEntry, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AddAbsenceEntryResponse>(`${this.basePath}/absence/entry`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editAbsenceEntry1(body?: AbsenceEntry, observe?: 'body', reportProgress?: boolean): Observable<EditAbsenceEntryResponse>;
    public editAbsenceEntry1(body?: AbsenceEntry, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditAbsenceEntryResponse>>;
    public editAbsenceEntry1(body?: AbsenceEntry, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditAbsenceEntryResponse>>;
    public editAbsenceEntry1(body?: AbsenceEntry, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EditAbsenceEntryResponse>(`${this.basePath}/absence/edit`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param body2 
     * @param body3 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAbsenceEntries1(body?: string, body2?: string, body3?: TimeInterval, observe?: 'body', reportProgress?: boolean): Observable<GetAbsenceEntriesResponse>;
    public getAbsenceEntries1(body?: string, body2?: string, body3?: TimeInterval, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAbsenceEntriesResponse>>;
    public getAbsenceEntries1(body?: string, body2?: string, body3?: TimeInterval, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAbsenceEntriesResponse>>;
    public getAbsenceEntries1(body?: string, body2?: string, body3?: TimeInterval, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.get<GetAbsenceEntriesResponse>(`${this.basePath}/absence/not-in-use`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param from 
     * @param to 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAbsenceEntriesWithStringInterval1(organization?: string, login?: string, from?: string, to?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAbsenceEntriesResponse>;
    public getAbsenceEntriesWithStringInterval1(organization?: string, login?: string, from?: string, to?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAbsenceEntriesResponse>>;
    public getAbsenceEntriesWithStringInterval1(organization?: string, login?: string, from?: string, to?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAbsenceEntriesResponse>>;
    public getAbsenceEntriesWithStringInterval1(organization?: string, login?: string, from?: string, to?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (login !== undefined && login !== null) {
            queryParameters = queryParameters.set('login', <any>login);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from);
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAbsenceEntriesResponse>(`${this.basePath}/absence/entries`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAbsenceEntry1(organization?: string, login?: string, id?: number, observe?: 'body', reportProgress?: boolean): Observable<GetAbsenceEntryResponse>;
    public getAbsenceEntry1(organization?: string, login?: string, id?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAbsenceEntryResponse>>;
    public getAbsenceEntry1(organization?: string, login?: string, id?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAbsenceEntryResponse>>;
    public getAbsenceEntry1(organization?: string, login?: string, id?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAbsenceEntryResponse>(`${this.basePath}/absence/entry`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param locale 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAbsenceReasons1(locale?: number, observe?: 'body', reportProgress?: boolean): Observable<GetAbsenceReasonsResponse>;
    public getAbsenceReasons1(locale?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAbsenceReasonsResponse>>;
    public getAbsenceReasons1(locale?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAbsenceReasonsResponse>>;
    public getAbsenceReasons1(locale?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (locale !== undefined && locale !== null) {
            queryParameters = queryParameters.set('locale', <any>locale);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAbsenceReasonsResponse>(`${this.basePath}/absence/reasons`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param locale 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAbsenceTypes1(organization?: string, locale?: number, observe?: 'body', reportProgress?: boolean): Observable<GetAbsenceTypesResponse>;
    public getAbsenceTypes1(organization?: string, locale?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAbsenceTypesResponse>>;
    public getAbsenceTypes1(organization?: string, locale?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAbsenceTypesResponse>>;
    public getAbsenceTypes1(organization?: string, locale?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (locale !== undefined && locale !== null) {
            queryParameters = queryParameters.set('locale', <any>locale);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAbsenceTypesResponse>(`${this.basePath}/absence/types`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCurrentAbsenceEntry1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAbsenceEntryResponse>;
    public getCurrentAbsenceEntry1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAbsenceEntryResponse>>;
    public getCurrentAbsenceEntry1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAbsenceEntryResponse>>;
    public getCurrentAbsenceEntry1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAbsenceEntryResponse>(`${this.basePath}/absence/current`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public isAbsenceEnabled1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<IsAbsenceEnabledResponse>;
    public isAbsenceEnabled1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IsAbsenceEnabledResponse>>;
    public isAbsenceEnabled1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IsAbsenceEnabledResponse>>;
    public isAbsenceEnabled1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<IsAbsenceEnabledResponse>(`${this.basePath}/absence/enabled`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeAbsenceEntry1(organization?: string, login?: string, id?: number, observe?: 'body', reportProgress?: boolean): Observable<RemoveAbsenceEntryResponse>;
    public removeAbsenceEntry1(organization?: string, login?: string, id?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveAbsenceEntryResponse>>;
    public removeAbsenceEntry1(organization?: string, login?: string, id?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveAbsenceEntryResponse>>;
    public removeAbsenceEntry1(organization?: string, login?: string, id?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<RemoveAbsenceEntryResponse>(`${this.basePath}/absence/entry`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeCurrentAbsenceEntries1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<RemoveCurrentAbsenceEntriesResponse>;
    public removeCurrentAbsenceEntries1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveCurrentAbsenceEntriesResponse>>;
    public removeCurrentAbsenceEntries1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveCurrentAbsenceEntriesResponse>>;
    public removeCurrentAbsenceEntries1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<RemoveCurrentAbsenceEntriesResponse>(`${this.basePath}/absence/current`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param duration 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setCurrentAbsenceEntry1(body?: AbsenceEntry, duration?: number, observe?: 'body', reportProgress?: boolean): Observable<SetCurrentAbsenceEntryResponse>;
    public setCurrentAbsenceEntry1(body?: AbsenceEntry, duration?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SetCurrentAbsenceEntryResponse>>;
    public setCurrentAbsenceEntry1(body?: AbsenceEntry, duration?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SetCurrentAbsenceEntryResponse>>;
    public setCurrentAbsenceEntry1(body?: AbsenceEntry, duration?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (duration !== undefined && duration !== null) {
            headers = headers.set('duration', String(duration));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SetCurrentAbsenceEntryResponse>(`${this.basePath}/absence/current`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
